var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenseTrackingEoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#EAF8ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#EAF8ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8126 14.0961C12.9076 14.0412 12.9866 13.9623 13.0414 13.8673C13.0963 13.7722 13.1251 13.6644 13.1251 13.5547V7.92969C13.1246 7.83004 13.1002 7.73198 13.054 7.64367C13.0079 7.55536 12.9413 7.47936 12.8598 7.42202C12.7783 7.36469 12.6842 7.32766 12.5855 7.31405C12.4868 7.30043 12.3863 7.31062 12.2923 7.34375C10.4681 7.98939 8.93396 9.26457 7.96575 10.9401C6.99755 12.6155 6.65875 14.5815 7.01027 16.4844C7.02849 16.5828 7.07008 16.6754 7.13153 16.7544C7.19298 16.8333 7.2725 16.8964 7.3634 16.9383C7.44531 16.9766 7.53468 16.9963 7.62511 16.9961C7.73481 16.9961 7.84259 16.9673 7.93761 16.9125L12.8126 14.0961ZM11.8751 8.87656V13.1937L8.13449 15.3523C8.12511 15.2344 8.12511 15.1156 8.12511 15C8.12622 13.7331 8.4769 12.4911 9.13855 11.4107C9.80019 10.3302 10.7471 9.45337 11.8751 8.87656ZM15.0001 6.875C14.8344 6.875 14.6754 6.94085 14.5582 7.05806C14.441 7.17527 14.3751 7.33424 14.3751 7.5V14.6734L8.21808 18.2602C8.14664 18.3016 8.0841 18.3567 8.0341 18.4225C7.9841 18.4882 7.94762 18.5632 7.92677 18.6431C7.90593 18.723 7.90112 18.8062 7.91263 18.888C7.92415 18.9698 7.95176 19.0485 7.99386 19.1195C8.71551 20.3463 9.74676 21.362 10.9844 22.065C12.222 22.7679 13.6226 23.1334 15.0458 23.1249C16.4691 23.1163 17.8652 22.734 19.0943 22.0163C20.3234 21.2986 21.3424 20.2706 22.0492 19.0352C22.7561 17.7998 23.1261 16.4004 23.1221 14.9771C23.118 13.5538 22.7402 12.1566 22.0264 10.9252C21.3126 9.69381 20.2878 8.67155 19.0547 7.96074C17.8216 7.24994 16.4234 6.87553 15.0001 6.875ZM15.0001 21.875C13.9091 21.8721 12.8342 21.6109 11.8634 21.1128C10.8927 20.6148 10.0537 19.894 9.41496 19.0094L15.315 15.5719C15.4099 15.5171 15.4887 15.4383 15.5436 15.3434C15.5984 15.2485 15.6273 15.1409 15.6275 15.0312V8.15313C17.3903 8.31306 19.0235 9.14675 20.1871 10.4806C21.3507 11.8145 21.9549 13.5458 21.8741 15.314C21.7932 17.0822 21.0335 18.7511 19.7531 19.9733C18.4727 21.1954 16.7702 21.8766 15.0001 21.875Z",
    fill: "#2EBB49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseTrackingEoy);
export default __webpack_public_path__ + "static/media/expense-tracking-eoy.7e9128aecaf3d07676c49b028a541c02.svg";
export { ForwardRef as ReactComponent };